import React from 'react'

export const AddressIcon = () => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 0.150391C9.83643 0.150391 12.8494 2.66539 12.8496 6.55957C12.8496 7.84649 12.3237 9.26766 11.25 10.8262C10.193 12.3604 8.61019 14.0173 6.5 15.8008C4.38981 14.0173 2.80702 12.3604 1.75 10.8262C0.676309 9.26766 0.150391 7.84649 0.150391 6.55957C0.150612 2.66539 3.16356 0.150391 6.5 0.150391ZM6.5 1.4502C3.69566 1.4502 1.47482 3.57271 1.47461 6.55957C1.47461 7.5365 1.8874 8.65402 2.70312 9.89062C3.51987 11.1288 4.74847 12.4983 6.39941 13.9834L6.5 14.0742L6.60059 13.9834C8.25153 12.4983 9.48013 11.1288 10.2969 9.89062C11.1126 8.65402 11.5254 7.5365 11.5254 6.55957C11.5252 3.57271 9.30434 1.4502 6.5 1.4502ZM6.5 4.9502C7.31311 4.9502 7.97461 5.60542 7.97461 6.40039C7.97439 7.19519 7.31298 7.84961 6.5 7.84961C5.68702 7.84961 5.02561 7.19519 5.02539 6.40039C5.02539 5.60542 5.68689 4.9502 6.5 4.9502Z"
      fill="#6B6B6B"
      stroke="white"
      strokeWidth="0.3"
    />
  </svg>
)
